<template>
    <div class="container-fluid w-100" style="overflow: hidden">
        <navbar :title="$t('area_report.title')"/>
        <!-- TODO - Add these to modals if needed!
        <nav class="navbar navbar-expand-lg navbar-dark header-background">
        <div class="container-fluid">
                <font-awesome-icon
                    v-if="detailsMode && areaReport.status !== completed && areaReport.reporter.id === userId && isNearBy"
                    icon="edit"
                    class="print-icon"
                    @click.stop="editAreaReportWizard"
                />
                <font-awesome-icon
                    v-if="detailsMode && areaReport.status !== completed && areaReport.reporter.id === userId"
                    icon="trash"
                    class="print-icon"
                    @click.stop="deleteReport"
                />
                <font-awesome-icon
                    v-if="detailsMode && areaReport.status === completed"
                    icon="print"
                    class="print-icon"
                    @click.stop="print"
                />
        </div>
        </nav>
        -->

        <div class="col-sm-12 nopads my-2">
            <area-report-filter
                v-if="!editMode && !detailsMode"
                :areas="areas"
                @search="fetchAreaReports"
            />
            <area-report-list
                v-if="!editMode && !detailsMode"
                :results="results"
                @details="showReportDetails"
                @add="startAreaReportWizard"
            />
            <base-modal v-if="editMode && !detailsMode" hide-footer hide-header size="xl" @close="editMode = false">
                <area-report-editor
                    v-if="editMode && !detailsMode"
                    :area-report="areaReport"
                    @close-and-update="closeAndFetchUpdate"
                    @close="closeAndFetchUpdate"
                />
            </base-modal>
            <base-modal v-if="detailsMode" hide-footer hide-header size="xl" @close="detailsMode = false">
                <area-report-details
                    v-if="detailsMode"
                    id="details"
                    ref="details"
                    :report-details="areaReport"
                    @close-and-update="closeAndFetchUpdate"
                />
            </base-modal>

            <!-- Loading Spinner -->
            <div v-if="loading" id="loader" class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import {areaReportHelper} from '../../mixins/AreaReportMixin'
import AreaReportEditor from './AreaReportEditor'
import AreaReportList from './AreaReportList'
import AreaReportDetails from './AreaReportDetails'
import AreaReportFilter from './AreaReportFilter'
import {isPointInPolygon} from "geolib";
import Navbar from "@/components/utils/Navbar.vue";
import BaseModal from "@/components/BaseModal";

export default {
    name: 'AreaReports',
    components: {BaseModal, Navbar, AreaReportFilter, AreaReportDetails, AreaReportList, AreaReportEditor},
    mixins: [restApi, areaReportHelper],
    props: {
        userId: {
            type: Number,
            default: -1
        }
    },

    data: function () {
        return {
            results: [],
            isNearBy: false,
            userPosition: null,
            areas: [],
            nearbyAreas: [],
            areaReport: null,
            editMode: false,
            detailsMode: false,
            loading: false,
            completed: 2,
            lastSearchParams: null,
            watchID: null
        }
    },

    mounted: function () {
        this.fetchAreas()
    },

    beforeUnmount() {
        if (this.watchID) {
            navigator.geolocation.clearWatch(this.watchID);
        }
    },

    methods: {
        fetchAreas: function () {
            this.loading = true
            this.restFetchParams(this.areaUrl, {no_geom: 1}, this.handleAreaResponse)
        },

        handleAreaResponse: function (response) {
            this.loading = false
            this.areas = response.data
            this.filterNearbyAreas()
        },

        filterNearbyAreas: function () {
            // TODO - user's distance to area can also be checked and then results sorted by distance
            this.nearbyAreas = []
            if (this.userPosition) {
                this.areas.forEach(area => {
                    if (isPointInPolygon(
                        {latitude: this.userPosition.coords.latitude, longitude: this.userPosition.coords.longitude},
                        this.getAreaPolygon(area))) {
                        this.nearbyAreas.push(area)
                    }
                }, this)
            }
        },

        watchUserPosition: function () {
            if (navigator.geolocation) {
                this.watchID = navigator.geolocation.watchPosition(position => {
                    this.setPosition(position)
                }, () => {
                }, {timeout: 30000, enableHighAccuracy: true})
            }
        },

        setPosition: function (position) {
            this.userPosition = position
            this.filterNearbyAreas()
        },

        fetchAreaReports: function (params) {
            if (params !== undefined && params !== null) {
                this.lastSearchParams = params
            }
            this.loading = true
            this.restFetchParams(this.areaReportUrl, this.lastSearchParams, this.handleResponse)
        },

        handleResponse: function (response) {
            this.loading = false
            this.results = response.data
        },

        editAreaReportWizard: function () {
            this.detailsMode = false
            this.editMode = true
        },

        startAreaReportWizard: function () {
            this.areaReport = null
            this.detailsMode = false
            this.editMode = true
        },

        showReportDetails: function (details) {
            this.areaReport = details
            this.detailsMode = true
            this.checkNearBy()
        },

        deleteReport: function () {
            this.$refs.details.confirmDeleteReport()
        },

        close: function () {
            this.editMode = false
            this.detailsMode = false
            this.areaReportWizardMode = false
            this.selectedArea = null
        },

        closeAndFetchUpdate: function () {
            this.close()
        },

        checkNearBy: function () {
            if (this.areaReport) {
                this.isNearBy = this.nearbyAreas.find(area => area.id === this.areaReport.area.id) !== undefined
            } else {
                this.isNearBy = false
            }
        }
    }
}
</script>
